export const en = {
  "month": {
  "1": "January",
  "2": "February",
  "3": "March",
  "4": "April",
  "5": "May",
  "6": "June",
  "7": "July",
  "8": "August",
  "9": "September",
  "10": "October",
  "11": "November",
  "12": "December"
  },
  "welcome": "Welcome",
  "navigation": {
    "dashboard": "Dashboard",
    "home": "Home",
    "standings": "Standings",
    "about": "About",
    "info": "Info",
    "login": "Login",
    "register": "Register",
    "profile": "Profile",
    "settings": "Settings",
    "actions": "Actions",
    "language": "Language",
    "createYourOwnCompetition": "Create your own competition!"
  },

  "app": {
    "welcomeTitle": "Tau Zero Tournaments",
    "welcomeMessage": "Create and manage custom competitions of all kinds: single-elimination tournaments, group stages with playoffs, single round-robin, F1-style championships and the more the merrier!",
    "dashboardDescription": "Manage your tournaments"
  },
  "common": {
    "country": "Country",
    "delete": "Delete",
    "loading": "Loading...",
    "error": "Error occurred",
    "save": "Save",
    "cancel": "Cancel",
    "email": "Email",
    "password": "Password",
    "required": "Required",
    "name": "Name",
    "confirmPassword": "Confirm Password",
    "login": "Login",
    "register": "Register",
    "logout": "Logout",
    "of": "of",
    "otherwise": "otherwise",
    "remove": "Remove",
    "close": "Close",
    "saveSettings": "Save Settings",
    "backToTournament": "Back to tournament",
    "confirm": "Confirm",
    "edit": "Edit",
    "editing": "Editing"
  },
  "auth": {
    "login": {
      "title": "Login",
      "subtitle": "Access your account",
      "emailLabel": "Email Address",
      "passwordLabel": "Password",
      "loginButton": "Login",
      "noAccount": "Don't have an account?",
      "registerLink": "Register here",
      "forgotPassword": "Forgot password?",
      "loginSuccess": "Login successful! Welcome back.",
      "loginError": "Invalid credentials. Please try again.",
      "resetPassword": "Reset Password"
    },
    "register": {
      "title": "Register",
      "subtitle": "Create your account",
      "nameLabel": "Name",
      "emailLabel": "Email Address",
      "passwordLabel": "Password",
      "confirmPasswordLabel": "Confirm Password",
      "registerButton": "Create Account",
      "hasAccount": "Already have an account?",
      "loginLink": "Login here",
      "registerSuccess": "Registration successful!",
      "registerError": "Registration failed. Please check your data.",
      "passwordMismatch": "Passwords do not match"
    },
    "validation": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters",
      "nameRequired": "Name is required",
      "confirmPasswordRequired": "Please confirm your password"
    }
    ,
    "reset": {
      "title": "Reset Password",
      "subtitle": "Enter your email to receive a password reset link",
      "emailLabel": "Email Address",
      "sendButton": "Send reset link",
      "sentSuccess": "If that email exists in our system, a reset link has been sent.",
      "sendError": "Could not send reset link. Please try again later.",
      "backToLogin": "Back to login"
    },
    "reset_confirm": {
      "title": "Set a new password",
      "subtitle": "Enter a new password for your account",
      "passwordLabel": "New Password",
      "confirmPasswordLabel": "Confirm Password",
      "resetButton": "Reset Password",
      "success": "Your password was reset successfully. You can now log in.",
      "error": "Unable to reset password. The token may be invalid or expired."
    }
  },
  "button": {
    "register": "Register",
    "addEntryToGroup": "Add Entry to Group",
    "addEntry": "Add Entry",
    "addNewParticipantToTournament": "Add a new participant to the tournament",
    "addNewTeamToTournament": "Add a new team to the tournament",
    "cancel": "Cancel",
    "addRound": "Add Round",
    "ok": "OK",
    "createNewSeason": "Create new season",
  },
  "messages": {
    "success": {
      "loginSuccess": "Login successful! Welcome back.",
      "registerSuccess": "Registration successful!"
    },
    "error": {
      "eventStarted": "The event has already started, cannot place bets",
      "eventFinished": "The event has already finished",
      "notFound": "Not found",
      "loadingBetsError": "Error loading bets",
      "loginError": "Invalid credentials. Please try again.",
      "registerError": "Registration failed. Please check your data."
    }
  },
  "message": {
    "tournamentSettingsSaved": "Tournament settings saved successfully",
    "errorSavingTournamentSettings": "Error saving tournament settings",
    "dataSaved": "Data saved successfully",
    "errorSavingData": "Error saving data",
    "standingsColumnsRequired": "Please select at least one standings column",
    "standingsSortingFieldsRequired": "Please select at least one standings sorting field",
    "addRoundsNoEntries": "You must add participants to the group first",
    "recalculateStandingsInfo": "Recalculate the standings based on completed rounds results.",
    "standingsRecalculatedSuccess": "Standings recalculated successfully.",
    "newSeasonCreatedSuccess": "New season created successfully.",
    "newSeasonCreatedError": "Error creating new season. Please try again.",
    "tournamentNotRunning": "Tournament is not running",
    "noRunningSeason": "No running season found",
    "youCantCloseSeason_reason": "You can't close now the season. Reason: {reason}",
    "cantDoAction_reason": "You can't do this action now. Reason: {reason}",
  },
  "alerts": {
    "verifyEmail": "Verify your email address to unlock all game features!",
    "verifyEmailSent": "A verification email has been sent to your address. Please check your inbox!",
    "verifyEmailError": "An error occurred while sending the verification email. Please try again later."
  },
  "actions": {
    "verifyEmail": "Verify email"
  },
  "tournament_action": {
    "recalculate_all_standings": "Recalculate all standings",
    "recalculate_all_standings_description": "Recalculate standings for all groups and stages based on completed rounds.",
    "recalculate_all_standings_button": "Recalculate",
    "award_prizes": "Award prizes",
    "award_prizes_description": "Assign prizes to the winners according to tournament rules.",
    "award_prizes_button": "Award"
    ,
    "create_new_season": "Create new season",
    "create_new_season_description": "Create a new season preserving participants and basic settings from the current tournament.",
    "create_new_season_button": "Create season",
    "close_season": "Close season",
    "close_season_description": "Close the current season and award prizes to the winners.",
    "close_season_description_full": "Close the current season, award prizes to the winners, and create a new season. This may take a while.",
    "close_season_button": "Close season"
  },
  "info": {
  "title": "Information",
  "joinDiscord": "Join our Discord",
  "subtitle": "Rules and how virtual betting works",
  "box1_title": "Create Any Competition",
  "box1_description": "Single elimination, round robin, Swiss system or FFA: choose the format and customize every detail. Perfect for sports, esports, and games of any kind.",
  "box2_title": "Maximum Flexibility, Zero Limits",
  "box2_description": "Combine formats and rules to build tailor-made competitions. From full-season leagues to quick tournaments: structure, scoring, and progression are up to you.",
  "box3_title": "Simple Yet Professional Management",
  "box3_description": "Manage participants, schedules, standings, and results with ease. Everything under control, from registration to crowning the champion."
  },
  "about": {
    "title": "About Us",
    "subtitle": "...",
    "mission": {
      "title": "Our Mission",
      "description": "..."
    },

    "team": {
      "title": "Our Team",
      "description": "A group of sports and technology enthusiasts who created this game for fun and to test predictive abilities."
    },
    "contact": {
      "title": "Community",
      "description": "Questions or suggestions?",
      "email": "Send us an email",
      "discord": "Join our Discord"
    },
    "version": "Version"
  },
  
  "profile": {
    "title": "Profile",
    "subtitle": "Manage your account and settings",
    "userInfo": {
      "title": "User Information",
      "welcome": "Welcome to your profile!",
      "username": "Username",
      "email": "Email address"
    },
    "quickActions": {
      "title": "Quick Actions",
      "goToSettings": "Go to Settings"
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Customize your gaming experience",
    "loading": "Loading settings...",
    "saveChanges": "Save Changes",
    "language": {
      "title": "Language",
      "subtitle": "Choose your preferred language",
      "select": "Select Language"
    },
  },
  "privacy": {
    "title": "Privacy",
    "subtitle": "Privacy and data information",
    "privacyAndCookies": "Privacy & Cookies",
    "content": {
      "title": "Privacy Policy",
      "dataUsage": "The few data we collect, namely username and email, are used only for things related to the game.",
      "noCookies": "There are no cookies or external scripts."
    },
    "assurance": {
      "title": "Your Privacy is Protected",
      "description": "We only collect essential data for the game to function and never share it with third parties.",
      "badge": "No Tracking"
    }
  },
  "notFound": {
    "title": "Page not found",
    "subtitle": "The page you are looking for does not exist or may have been removed.",
    "backHome": "Back to home"
  },
  "filterNotFound": {
    "season": "Season {value} not found.",
    "level": "Level {value} not found.",
    "stage": "Stage {value} not found.",
    "group": "Group {value} not found."
  },
  "tournaments": {
    "slug": "URL Path",
    "teamStandings": "Team Standings",
    "createNew": "Create New Tournament",
    "entries": "Entries",
    "newTournament": "New Tournament",
    "tournamentName": "Tournament Name",
    "description": "Description",
    "createdSuccess": "Tournament created successfully!",
    "createdError": "Error creating tournament. Please try again.",
    "create": "Create",
    "cancel": "Cancel",
    "differentTypeForNextStages": "You can choose a different type of competition for the next stages, for example a round-robin followed by a knockout",
    "startFromTemplate": "Start from Template",
    "startFromTemplateDesc": "Start from a predefined model, such as F1, football championship, knockout tournament",
    "customTournament": "Custom Tournament",
    "customTournamentDesc": "Create a completely custom tournament from scratch",
    "next": "Next",
    "back": "Back",
    "saveDraft": "Save Draft",
    "step1Title": "Tournament setup",
    "step2Title": "Format",
    "basic_info": "Basic Info",
    "competitionType": "Competition Type",
    "stagesSetup": "Stages Setup",
    "stage_n": "Stage {n}",
    "addStage": "Add more stages",
    "singleStage": "Single Stage",
    "multipleStages": "Multiple Stages",
    "singleStageDesc": "There is only one stage in the tournament, whoever wins this wins the tournament. For example, a knockout tournament like a national football cup, or the F1 championship",
    "multipleStagesDesc": "Winners of one stage advance to the next stage. For example, the FIFA World Cup which has a group stage followed by a knockout stage",
    "numberOfStages": "Number of Stages",
    "numberOfParticipants": "Number of Participants",
    "participantsMinimum": "Must be greater than 1",
    "participantsExceedPrevious": "Cannot exceed the number of participants from the previous stage",
    "expectedParticipants": "Expected Participants",
    "numberOfGroups": "Number of Groups",
    "qualificationRules": "Qualification Rules",
    "qualifiedPerGroup": "Qualified per Group",
    "qualifiedPerGroupHint": "Number of teams/players advancing to the next stage from each group",
    "addEntryToGroup": "Add Entry to Group",
    "selectEntry": "Select Entry",
    "addNewParticipant": "Add New Participant",
    "entryCreatedSuccess": "Participant created successfully",
    "teamCreatedSuccess": "Team created successfully",
    "entryCreatedError": "Error creating participant. Please try again.",
    "roundsAddedSuccess": "Rounds added successfully",
    "entryUpdatedSuccess": "Participant updated successfully",
    "teamUpdatedSuccess": "Team updated successfully",
    "editParticipant": "Edit Participant",
    "addNewTeam": "Add New Team",
    "editTeam": "Edit Team",
    "deleteEntry": "Delete participant",
    "deleteEntryConfirm": "Are you sure you want to delete this participant?",
    "deleteTeam": "Delete team",
    "deleteTeamConfirm": "Are you sure you want to delete this team?",
    "deleteRound": "Delete round",
    "deleteRoundConfirm": "Are you sure you want to delete this round?",
    "roundDeletedSuccess": "Round deleted successfully",
    "roundDeletedError": "Error deleting round. Please try again.",
    "entryDeletedSuccess": "Participant deleted successfully",
    "teamDeletedSuccess": "Team deleted successfully",
    "entryDeletedError": "Error deleting participant. Please try again.",
    "noParticipantsTitle": "No participants registered",
    "noParticipantsMessage": "Add participants to the tournament to be able to select them here.",
    "noGroupParticipantsMessage": "Add participants to the group to be able to select them here.",
    "yourTournaments": "Your Tournaments",
    "noTournaments": "You haven't created any tournaments yet. Create your first tournament now!",
    "removeFromGroup": "Remove from group",
    "removeFromGame": "Remove from game",
    "noRounds": "No rounds scheduled",
    "removeFromGroupConfirm": "Are you sure you want to remove this participant from the group?",
    "removeFromGameConfirm": "Are you sure you want to remove this participant from the game?",
    "upcomingRound": "Upcoming round",
    "viewDetails": "View details",
    "showTeamStandings": "Show team standings",
    "showMainStandings": "Show main standings",
  },

  "competitionTypes": {
    "knockout": "Knockout",
    "round_robin": "Round Robin",
    "ffa": "Free For All",
    "swiss": "Swiss System"
  },
  "competitionTypesDesc": {
    "knockout": "Single-elimination tournament where losers are eliminated",
    "round_robin": "Each team plays all other teams once",
    "ffa": "All participants compete at the same time, the winner is the one with the highest score"
  },

  "entryFlags": {
    "dnf": "DNF",
    "pole": "Pole position"
  },

  "tournamentStates": {
    "draft": "Draft",
    "open": "Open",
    "running": "Running",
    "completed": "Completed",
    "archived": "Archived",
    "cancelled": "Cancelled"
  },

  "roundStates": {
    "scheduled": "Scheduled",
    "running": "Ongoing",
    "completed": "Completed",
    "cancelled": "Cancelled"
  },

  "label": {
    "competition": "Tournament",
    "format": "Format",
    "started_on_date": "Started on {date}",
    "enableTeams": "Enable Teams",
    "manage_teams": "Manage teams",
    "entry_number": "No.",
    "team": "Team",
    "tournamentType": "Tournament Type",
    "type": "Type",
    "participants": "Participants",
    "dashboard": "Dashboard",
    "examples": "Examples",
    "standings": "Standings",
    "fixtures": "Fixtures",
    "selectParticipant": "Select Entry",
    "manage_entries": "Manage entries",
    "state": "State",
    "standingsColumns": "Standings Columns",
    "standingsColumnsDescription": "Select and order the columns to display in standings tables",
    "standingsSortingFields": "Standings Sorting",
    "standingsSortingFieldsDescription": "Choose how to sort the standings. Select the fields and their order.",
    "name": "Name",
    "description": "Description",
    "tournamentSettings": "Tournament settings",
    "options": "Options",
    "showFlags": "Show flags",
    "mainColor": "Main color",
    "add_N_rounds": "Add {n} rounds",
    "round_n": "Round {n}",
    "editRound": "Edit round",
    "group_n": "Group {n}",
    "entry": "Entry",
    "season": "Season",
    "season_n": "Season {n}",
    "level": "Division",
    "level_n": "Division {n}",
    "group": "Group",
    "notes": "Notes",
    "recalculateStandings": "Recalculate standings",
    "tournament_info": "Tournament info",
    "sortAutomaticallyAfterSaving": "Auto-sort after saving",
    "stage": "Stage",
    "stage_n": "Stage {n}",
    "createNewSeason": "Create new season",
    "createNewSeason_n": "Create season {n}",
    "close_season_n": "Close season {n}"
  },
  "round": {
    "viewResults": "View results"
  },
  "standingsColumns": {
    "name": "Name",
    "points": "Points",
    "played": "Played",
    "wins": "Wins",
    "draws": "Draws",
    "losses": "Losses",
    "score_for": "Goals For",
    "score_against": "Goals Against",
    "score_difference": "Goal Difference",
    "podiums": "Podiums",
    "dnf": "DNF"
  },
  "sortingType": {
    "asc": "Ascending",
    "desc": "Descending"
  },

  "help": {
    "tournament_entries_title": "Tournament Participants",
    "tournament_entries_description": "In this section you can manage the participants of the tournament. You will then need to add them to groups to see and use them in standings and events. This section contains all participants associated with the tournament, including those who have withdrawn or those who have yet to be assigned to a group.",
    "tournament_teams_title": "Tournament Teams",
    "tournament_teams_description": "Participants in the tournament can be grouped into teams. This is mainly useful for FFA tournaments, like Formula 1 or cycling. Football \"teams\" are participants, so they should not be added here."
  },

  "hof": {
    "rewardsInfo": "Rewards can be automatically awarded when a season ends.\nBut from here, you can manually add or remove a reward if you wish.",
    "addRewardToEntry": "Add Reward to Entry",
    "addRewardToTeam": "Add Reward to Team",
    "awardType": "Award Type"
  },

  "award_types": {
    "winner": "Winner",
    "runner_up": "Runner-up",
    "third_place": "Third Place"
  }
}